import React from 'react';
import styled from 'styled-components';

import { AgentProfile, AppointmentItemActions } from 'components';
import { AppointmentPermission } from 'components/List/ListItems/AppointmentItemActions';
import { buildListingFullAddress } from 'utils';

import type { AppointmentTask } from '@/app-package';
import DateSection from './DateSection';
import TaskLayout from './TaskLayout';

type AppointmentRequestedItemProps = {
  itemData: AppointmentTask['data'];
  permission?: AppointmentPermission;
  team?: boolean;
};

const AppointmentRequestedItem: React.FC<AppointmentRequestedItemProps> = ({
  itemData,
  permission,
  team,
}) => {
  const listingAddress = buildListingFullAddress(
    itemData.line1,
    itemData.line2,
  );

  return (
    <TaskLayout
      title="Showing Requested"
      content={
        <>
          <DateSection startDate={itemData.time} endDate={itemData.timeEnd} />
          <AddressContainer>{listingAddress}</AddressContainer>
          <AgentProfile user={itemData.coop} showOrgName nameTextStrong />
        </>
      }
      buttons={
        <AppointmentItemActions
          appointmentId={itemData.appointmentId}
          permission={permission}
          team={team}
          listingId={itemData.listingId}
        />
      }
      dataCy={`showing-request-item-${itemData.appointmentId}`}
    />
  );
};

export default AppointmentRequestedItem;

const AddressContainer = styled.div`
  margin: 2px 0 4px 0;
`;
